








































































import LowModel from '@/components/models/Index.vue'
import LowAsidePage from '@/components/aside-page/Index.vue'
import LowActions from '@/components/actions/Index.vue'
import { Component, Vue, Provide } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { LowElement } from '@/types/Element';
import { ModelType } from '@/store/entities/Page';
@Component({
  name: 'low-aside',
  components: {
    LowModel,
    LowActions,
    LowAsidePage
  }
})
export default class LowAside extends Vue {

  activeAction: 'components' | 'models' | 'actions' | 'page' = 'page';

  @State('globalModels')
  models?: ModelType[];

  @State('currentId', { namespace: 'page' })
  currentId?: string;

  @Getter('current', { namespace: 'page' })
  current?: LowElement;

  @Provide('draggableOptions')
  draggableOptions = {
    clone: true,
    group: {
      name: 'container',
      pull: 'clone',
      put: false,
      disabled: true,
    }
  }

  elements = [
    {
      type: 'layout',
      element: 'layout',
      label: "功能",
      disabled: true,
      children: [
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "input",
              "type": "element",
              "name": "输入框组件",
              "clone": true,
              "props": {}
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "button",
              "type": "element",
              "name": "按钮组件",
              "clone": true,
              "props": {
                "text": '按钮名称'
              }, // 参数
            }
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "text",
              "type": "element",
              "name": "文字组件",
              "clone": true,
              "props": {
                "text": '文字组件'
              }, // 参数
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "tag",
              "type": "element",
              "name": "标签",
              "clone": true,
              "props": {
                "text": '标签一'
              }, // 参数
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "progress",
              "type": "element",
              "name": "进度条",
              "clone": true,
              "props": {
                percentage: 43
              }, // 参数
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "pagination",
              "type": "element",
              "name": "分页",
              "clone": true,
              "props": {
                total: 100
              }, // 参数
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "alert",
              "type": "element",
              "name": "警告",
              "clone": true,
              "props": {
                title: "提示的文案"
              }, // 参数
            },
          ]
        },
      ]
    },
    {
      type: 'layout',
      element: 'layout',
      label: "容器",
      disabled: true,
      children: [
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              name: "行",
              "element": "row", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              disabled: true,
              children: [
                {
                  "element": "col", // 元素名称 or 类型
                  "type": "container", // container or element
                  "clone": true,
                  name: "列",

                  props: {
                    span: 12
                  }
                }, {
                  "element": "col", // 元素名称 or 类型
                  "type": "container", // container or element
                  "clone": true,
                  name: "列",

                  props: {
                    span: 12
                  }
                },
              ]
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "col", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              name: "列",

              props: {
                span: 6
              }
            },
          ]
        }, {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "block", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              name: "块元素",

              props: {}
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              name: "表单",
              "element": "form", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              disabled: true,
              props: {
                size: 'mini'
              },
              children: [
                {
                  "element": "form-item", // 元素名称 or 类型
                  "type": "container", // container or element
                  disabled: true,
                  props: {
                    label: "表单项"
                  },
                  children: [
                    {
                      disabled: true,
                      "element": "input", // 元素名称 or 类型
                      "type": "element", // container or element
                      props: {
                      },
                    },
                  ]
                },
                {
                  "element": "form-item", // 元素名称 or 类型
                  "type": "container", // container or element
                  disabled: true,
                  props: {
                    label: "表单项"
                  },
                  children: [
                    {
                      disabled: true,
                      "element": "input", // 元素名称 or 类型
                      "type": "element", // container or element
                      props: {
                      },
                    },
                  ]
                },
                {
                  "element": "form-item", // 元素名称 or 类型
                  "type": "container", // container or element
                  disabled: true,
                  props: {
                    label: "表单项"
                  },
                  children: [
                    {
                      disabled: true,
                      "element": "button", // 元素名称 or 类型
                      "type": "element", // container or element
                      props: {
                        text: "按钮",
                      },
                    },
                  ]
                },
              ]
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "table", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              disabled: true,
              props: {
                columns: [
                  {
                    id: "id",
                    label: "编号"
                  },
                  {
                    id: "name",
                    label: "名称"
                  }
                ]
              },
              children: [
                {
                  "element": "button", // 元素名称 or 类型
                  "type": "element", // container or element
                  disabled: true,
                  props: {
                    type: "text",
                    size: 'mini',
                    text: '查看'
                  },
                },
              ]
            },
          ]
        }

      ]
    },
    {
      type: 'layout',
      element: 'layout',
      label: "表单",
      disabled: true,
      children: [
        {
          element: 'block',
          type: 'contailner',
          disabled: true,
          children: [
            {
              "element": "form", // 元素名称 or 类型
              "type": "container", // container or element
              "clone": true,
              // disabled: true,
              props: {
                size: 'mini'
              },
              children: [
                {
                  "element": "form-item", // 元素名称 or 类型
                  "type": "container", // container or element
                  disabled: true,
                  props: {
                    label: "表单项"
                  },
                  children: [
                    {
                      disabled: true,
                      "element": "input", // 元素名称 or 类型
                      "type": "element", // container or element
                      props: {
                      },
                    },
                  ]
                },
              ]
            },
          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [
            {
              "element": "radio",
              "type": "element",
              "name": "单选框",
              "clone": true,
              "props": {
                options: [
                  {
                    label: "备选项1",
                    value: "1",
                  },
                  {
                    label: "备选项2",
                    value: "2",
                  }
                ]
              }, // 参数
            },

          ]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "checkbox",
            "type": "element",
            "name": "多选框",
            "clone": true,
            "props": {
              options: [
                {
                  label: "备选项1",
                  value: "12",
                },
                {
                  label: "备选项2",
                  value: "23",
                }
              ]
            }, // 参数
          }]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "select",
            "type": "element",
            "name": "多选框",
            "clone": true,
            "props": {
              options: [
                {
                  label: "备选项1",
                  value: "12",
                },
                {
                  label: "备选项2",
                  value: "23",
                }
              ]
            }, // 参数
          },]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "switch",
            "type": "element",
            "name": "开关",
            "clone": true,
            "props": {}, // 参数
          }]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "slider",
            "type": "element",
            "name": "滑块",
            "clone": true,
            "props": {}, // 参数
          }]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "time-picker",
            "type": "element",
            "name": "时间选择器",
            "clone": true,
            "props": {}, // 参数
          }]
        },
        {
          element: 'block',
          type: 'contailner',
          children: [{
            "element": "date-picker",
            "type": "element",
            "name": "日期选择器",
            "clone": true,
            "props": {}, // 参数
          }]
        }
      ]
    }
  ]
}
